var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GeneralContainer',[_c('div',{staticClass:"contact"},[_c('h1',[_vm._v("Contact Us")]),_c('ContactForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }